<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      title="Création d'un lot">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <lot-form
          @submit="createLot"
          :source-loading="loading"
          :source-lot-program="lotProgram"></lot-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import LotMixin from './LotMixin'

export default {
  name: 'LotDuplicate',
  components: {
    LotForm: () => import('@/components/lots/LotForm')
  },
  mixins: [LotMixin]
}
</script>
